import React from "react";
import { Container, Spinner } from "react-bootstrap";
import { useLanguage } from "../../context/LanguageContext.js";
import { t } from "../../utils/translations.js";

export default function LoadingSpinner({ fullPage = false }) {
  const { language } = useLanguage();

  if (fullPage) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">{t(language, "loading")}</span>
        </Spinner>
      </Container>
    );
  }

  return (
    <div className="text-center py-4">
      <Spinner animation="border" role="status" size="sm">
        <span className="visually-hidden">{t(language, "loading")}</span>
      </Spinner>
    </div>
  );
}
